import React from "react";

export default function WhatsAppIcon({ size, fill }) {
  return (
    <svg
      width={size ? size : "56"}
      height={size ? size : "56"}
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M47.5 8.25C52.75 13.5 56 20.375 56 27.875C56 43.125 43.25 55.625 27.875 55.625C23.25 55.625 18.75 54.375 14.625 52.25L0 56L3.875 41.625C1.5 37.5 0.125 32.75 0.125 27.75C0.125 12.5 12.625 0 27.875 0C35.375 0 42.375 3 47.5 8.25ZM27.875 50.875C40.625 50.875 51.25 40.5 51.25 27.875C51.25 21.625 48.625 15.875 44.25 11.5C39.875 7.125 34.125 4.75 28 4.75C15.25 4.75 4.875 15.125 4.875 27.75C4.875 32.125 6.125 36.375 8.375 40.125L9 41L6.625 49.5L15.375 47.125L16.125 47.625C19.75 49.75 23.75 50.875 27.875 50.875ZM40.625 33.625C41.25 34 41.75 34.125 41.875 34.5C42.125 34.75 42.125 36.125 41.5 37.75C40.875 39.375 38.125 40.875 36.875 41C34.625 41.375 32.875 41.25 28.5 39.25C21.5 36.25 17 29.25 16.625 28.875C16.25 28.375 13.875 25.125 13.875 21.625C13.875 18.25 15.625 16.625 16.25 15.875C16.875 15.125 17.625 15 18.125 15C18.5 15 19 15 19.375 15C19.875 15 20.375 14.875 21 16.25C21.5 17.625 23 21 23.125 21.375C23.25 21.75 23.375 22.125 23.125 22.625C21.875 25.25 20.375 25.125 21.125 26.375C23.875 31 26.5 32.625 30.625 34.625C31.25 35 31.625 34.875 32.125 34.5C32.5 34 33.875 32.375 34.25 31.75C34.75 31 35.25 31.125 35.875 31.375C36.5 31.625 39.875 33.25 40.625 33.625Z"
        fill={fill ? fill : "#DADADA"}
      />
    </svg>
  );
}
